import type { GuardArgs } from '@sg/machines';

import { getSessionRetryDelay } from './delays';

import type { AuthEvent } from './events';
import type { AuthContext, CheckIfSessionIsLoggedInParams } from './types';

// ─────────────────────────────────────────────────────────────────────────────

const checkIfSessionIsLoggedIn: Guard<CheckIfSessionIsLoggedInParams> = (_args, params) => {
  return params.isLoggedIn;
};

const checkIfSessionRetryIsDelayed: Guard = ({ context }) => {
  return getSessionRetryDelay(context.sessionFailureCount) > 0;
};

export const AuthMachineGuards = {
  checkIfSessionIsLoggedIn,
  checkIfSessionRetryIsDelayed,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Guard<GuardParams extends Record<string, unknown> | void = void> = (
  args: GuardArgs<AuthContext, AuthEvent>,
  params: GuardParams,
) => boolean;
